/**
 * English (`en`) texts of the NEUTRAL vocabulary of a lot's states (OBR-14): what the BackOffice, the planta app and the
 * console say the same way. Namespace `domain.stockStates` (keys found by `stockStateReason`, `stockBlockReasonKey` and
 * `stockLotStateKey` in `domain/stockStates.ts`) and `backoffice.stockErrors`: the errors of the Existences RPCs that the
 * screen cannot prevent with its own validation. Own slice: `en.ts` is not touched. The three languages must have the same
 * keys (i18n.test.ts).
 */

export const statesEn = {
  'domain.stockStates': {
    state_available: 'Available',
    state_blocked: 'Blocked',
    state_expired: 'Expired',
    state_soon: 'Expires soon',
    stateBlockedLong: 'Blocked / Quarantine',

    blockReason_expired: 'Expired',
    blockReason_manual: 'Blocked by hand',
    blockReason_return: 'Return waiting to leave',
    blockReason_exception: 'Reception exception waiting for a decision',

    reasonConsumeBlocked: 'Blocked: it cannot be consumed or shipped.',
    reasonConsumeExpired: 'Expired: it cannot be consumed or shipped.',
    reasonMoveWarning:
      'This lot is not available. You can move it, but it cannot be consumed or shipped until it is available again. If it is blocked by hand, the destination place is blocked too: the quarantine follows the goods.',
    reasonAdjustExpired: 'The lot has expired: the recommended reason is “Expired”.',
  },

  'backoffice.stockErrors': {
    badQuantity: 'The quantity must not be zero.',
    badReason: 'Choose a reason from the list.',
    noteRequired: 'The reason for the adjustment must be written down.',
    twoLots: 'A movement belongs to one lot only: choose just one.',
    unknownArticle: 'This article does not exist in this obrador.',
    clientUuidConflict: 'This operation already belongs to another movement. Reopen the dialog and try again.',
    untracked: 'This article has no stock control.',
    unknownLot: 'This lot does not exist or does not belong to this article.',
    stateBadState: 'That state cannot be chosen: only Available or Blocked.',
    stateLotRequired: 'Choose a lot (just one) to change its state.',
  },
} as const;
